// src/pages/account/AppearancePage.jsx
import AppearancePanel from "./AppearancePanel";
export default function AppearancePage() {
  return <AppearancePanel />;
}